module.exports = __webpack_public_path__ + "img/4-1.22a4eb9d.svg";